<div
  class="map-card-img-wrapper"
  [ngStyle]="{ 'height.px': height, 'width.px': width }"
  [ngSwitch]="fetching"
>
  <div *ngSwitchCase="true" class="placeholder-map shimmer"></div>

  <ng-container *ngSwitchDefault>
    <a
      *ngIf="mapImageUrl && externalMapsUrl"
      [attr.href]="externalMapsUrl"
      target="_blank"
      trackable
      [trackingObject]="trackingObject"
      [trackingAction]="trackingAction"
    >
      <!-- TODO: determine whether we need to translate the `alt` text or not -->
      <img
        class="map-card-img"
        [attr.src]="mapImageUrl"
        alt="Map location at latitude: {{ latitude }} and longitude: {{
          longitude
        }}"
      />
    </a>
  </ng-container>
</div>
